import App from './App.vue'
import router from './router'

import PermissionDirective from '@/directives/permission'
import { VueMaskDirective } from 'v-mask'
import Vue from 'vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import InputFacade from 'vue-input-facade'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

import Notifications from 'vue-notification'
import VueSocketIOExt from 'vue-socket.io-extended'

// import VueToastr from '@deveodk/vue-toastr'
// import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

import VueSweetalert2 from 'vue-sweetalert2'
import VueToastr from 'vue-toastr'
import VueLogger from 'vuejs-logger'

import DateTextEdit from './components/shared/DateTextEdit'
import TimeTextEdit from './components/shared/TimeTextEdit'
import socket from './plugins/socket'
import vuetify from './plugins/vuetify'
import store from './store'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@mdi/font/css/materialdesignicons.css'

// Latin subset only (locales are es/en), and only the weights referenced in src/.
import '@fontsource/roboto/latin-300.css'
import '@fontsource/roboto/latin-400.css'
import '@fontsource/roboto/latin-500.css'
import '@fontsource/roboto/latin-600.css'
import '@fontsource/roboto/latin-700.css'

import '@/plugins/StringPrototype'
import '@/plugins/validationRules'
import DatePlugin from '@/plugins/date.plugin'
import '@/plugins/uuidService'
import '@/assets/styles/styles.css'
import '@/plugins/httpService'
import i18n from '@/plugins/i18n.plugin'

import DateService, { FMT } from './helpers/DateService'

Vue.config.productionTip = false

// Plugins
Vue.use(DatePlugin)

// Log
const isProduction = process.env.NODE_ENV === 'production'
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, options)

// Socket IO
Vue.use(VueSocketIOExt, socket, {
  store,
  mutationPrefix: 'SOCKET_',
  eventToMutationTransformer: (mutationName) => mutationName,
  actionPrefix: 'SOCKET_',
  eventToActionTransformer: (actionName) => actionName
})

// Notifications
Vue.use(Notifications)

// DateTextEdit y TimeTextEdit component
Vue.component('VxDateTextEdit', DateTextEdit)
Vue.component('VxTimeTextEdit', TimeTextEdit)

// Vue CTK DateTimePicker
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

// Control de permisos
Vue.directive('permission', PermissionDirective)

// Masks
Vue.directive('mask', VueMaskDirective)
Vue.use(InputFacade)

// Toastr
/* Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-right',
  defaultType: 'info',
  defaultTimeout: 5000
}) */
Vue.use(VueToastr, {
  defaultTimeout: 5000,
  defaultProgressBar: false,
  defaultProgressBarValue: 0,
  defaultType: 'info',
  defaultPosition: 'toast-bottom-right',
  defaultCloseOnHover: true,
  // defaultStyle: { 'background-color': 'red' },
  defaultStyle: { 'font-family': 'Helvetica' },
  defaultClassNames: ['animated', 'zoomInUp']
})

// SweetAlert dialogs
const swalOptions = {
  reverseButtons: true,
  confirmButtonColor: '#00496f',
  cancelButtonColor: '#cccccc'
}
Vue.use(VueSweetalert2, swalOptions)

Vue.filter('formatDate', (value, format = FMT.date) => {
  if (!value) return '-'
  return DateService.toDayjs(value, format).format(format)
})

Vue.prototype.$eventHub = new Vue()

const vueInstance = new Vue({
  i18n,
  router,
  store,
  vuetify,
  sockets: {
    connect() {
      console.log('Socket conectado')
    },
    disconnect: () => {
      console.log('socket disconnected')
    },
    reconnect: () => {
      console.log('socket reconnect')
      store.dispatch('app/reSyncAfterReconnect', null, { root: true })
    }
  },
  render: h => h(App)
})
vueInstance.$mount('#app')

export default vueInstance
